<div bsModal #modal="bs-modal" class="modal fade theme-custom" tabindex="-1" role="dialog" aria-labelledby="modal"
    (onShown)="onShown()" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #editForm="ngForm" novalidate (ngSubmit)="save()">
                <div class="modal-header">
                    <!-- <label class="modal-title"> -->
                    <h5 class="capitalize-text m-0">{{l("NotificationSettings")}}</h5>
                    <!-- </label> -->
                    <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" *ngIf="settings">
                    <div>
                        <label attr.for="receiveNotifications" class="m-checkbox">
                            <input id="receiveNotifications" type="checkbox" name="receiveNotifications"
                                [(ngModel)]="settings.receiveNotifications">
                            {{l("ReceiveNotifications")}}
                            <span></span>
                        </label>
                        <div class="help-block">{{l("ReceiveNotifications_Definition")}}</div>
                    </div>
                    <label *ngIf="settings.notifications.length"
                        class="m--margin-top-20">{{l("NotificationTypes")}}</label>
                    <p *ngIf="settings.notifications.length && !settings.receiveNotifications" class="text-danger">
                        <small>{{l("ReceiveNotifications_DisableInfo")}}</small>
                    </p>
                    <div class="m-checkbox-list">
                        <div *ngFor="let notification of settings.notifications">
                            <label attr.for="Notification_{{notification.name}}" class="m-checkbox">
                                <input id="Notification_{{notification.name}}" type="checkbox"
                                    name="Notification_{{notification.name}}" [(ngModel)]="notification.isSubscribed"
                                    [disabled]="!settings.receiveNotifications">
                                {{notification.displayName}}
                                <span></span>
                            </label>
                            <span *ngIf="notification.description"
                                class="help-block">{{notification.description}}</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default"
                        (click)="close()">{{l("Cancel")}}</button>
                    <button type="submit" class="btn btn-primary" [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"><i class="fa fa-save"></i>
                        <span>{{l("Save")}}</span></button>
                </div>
            </form>
        </div>
    </div>
</div>